import React from "react";
import styles from "./styles";
import { withStyles } from "@material-ui/core/styles";
import appConstants from "../../../../../../../../appConstants";
import { StyledRadioGroup } from "../../../common/RadioGroup";
import CheckboxGroup from "../../../common/CheckboxGroup";
import Select from "../../../../../../../common/StyledSelect";
import Collapse from "@material-ui/core/Collapse";
import { observer, inject } from "mobx-react";
import ShrinkWrap from "./ShrinkWrap";
import ExcessiveLength from "../../../common/ExcessiveLength";
import FormSectionHeader from "../../common/FormSectionHeader";
import PaymentDetails from "./../../Payment/PaymentDetails";
import { isPaymentDetailsRequired } from "../../Payment/util";
import SelectBills from "../SelectBills";
import { getPendingStops } from "../../../../../utils/utils";
import { getExcessiveShipmentList } from "../../../PickupProcessing/util";
import MESSAGES from "../../../../../../../../appMessages";
import ReturnDetails from "../ReturnDetails";
import { compose } from "recompose";
import { withAppConfig } from "@appConfigContext";

@inject("DispatchStore")
@observer
class Form extends React.Component {
  handleChange = (name) => (value) => {
    const { handleChange } = this.props;
    if (["limitedAccessCode", "returnCode"].includes(name)) {
      value = value && value.value;
    }
    handleChange && handleChange(name)(value);
  };

  getAccessorialsOptions = () => {
    const { editInfo, DispatchStore } = this.props;
    
    if (editInfo.accessorials.length) {
      return editInfo.accessorials;
    }
    
    return DispatchStore.deliveryAccessorials;
  };

  render() {
    const { classes } = this.props;
    const {
      editInfo,
      errorInfo,
      shipmentData,
      children,
      forwardRef,
      routeData,
      stopData,
      stopHasMultiplePros,
      updateStopSelection,
      getDeliveryStatusFlags,
    } = this.props;
    const isLimitedAccessChecked =
      editInfo.accessorials.length > 0
        ? editInfo.accessorials.find(
            (ele) => ele.name === appConstants.ACCESSORIAL.LIMITED_ACCESS
          )?.isChecked
        : false;
    const {
      isReturnDelivery,
      isTADelivery,
      isDEDelivery,
      isReturnOrSNDDelivery,
      shouldShowExcessiveLength
    } = getDeliveryStatusFlags(shipmentData.proId);

    return (
      <React.Fragment>
        <div id={shipmentData.proId} ref={forwardRef}>
          {isPaymentDetailsRequired({
            deliveryStatus: editInfo.deliveryStatus,
            codAmount: shipmentData?.codAmount,
            freightAmount: shipmentData?.freightAmount,
          }) && (
            <PaymentDetails
              handleChange={this.handleChange}
              data={{
                freightAmount: shipmentData?.freightAmount,
                originalFreightAmount: shipmentData?.originalFreightAmount,
                freightPaymentType: editInfo.freightPaymentType,
                freightCheckNumber: editInfo.freightCheckNumber,
                freightAmountCollected: editInfo.freightAmountCollected,
                codAmount: shipmentData?.codAmount,
                originalCodAmount: shipmentData?.originalCodAmount,
                codPaymentType: editInfo.codPaymentType,
                codCheckNumber: editInfo.codCheckNumber,
                codAmountCollected: editInfo.codAmountCollected,
              }}
              errorInfo={errorInfo}
            />
          )}
          <FormSectionHeader label="Delivery Status" uppercase />
          <StyledRadioGroup
            onChange={this.handleChange("deliveryStatus")}
            options={this.props.DispatchStore.deliveryStatuses}
            helperText={errorInfo.deliveryStatus}
            error={Boolean(errorInfo.deliveryStatus)}
            value={editInfo.deliveryStatus}
          />
          {children}

          <ReturnDetails
            editInfo={editInfo}
            errorInfo={errorInfo}
            onChange={this.handleChange}
            isReturnDelivery={isReturnDelivery}
            shipmentPieces={shipmentData.pieces}
            isDEDelivery={isDEDelivery}
          />

          <Collapse
            in={!isReturnOrSNDDelivery}
            timeout="auto"
            >
            <FormSectionHeader label="Accessorials" uppercase />
            <CheckboxGroup
              options={this.getAccessorialsOptions()}
              onChange={this.handleChange("accessorials")}
              errorMessage={errorInfo.accessorials}
              />
              {isLimitedAccessChecked && (
                <>
                  <FormSectionHeader label="Limited Access Details" uppercase />
                  <div className={classes.flexRow}>
                    <Select
                      textFieldProps={{
                        id: "limitedAccessCode",
                        label: "Limited Access",
                        variant: "outlined",
                        helperText: errorInfo.limitedAccessCode,
                      }}
                      error={Boolean(errorInfo.limitedAccessCode)}
                      value={editInfo.limitedAccessCode}
                      onChange={this.handleChange("limitedAccessCode")}
                      data={this.props.DispatchStore.limitedAccessList}
                    />
                  </div>
                </>
              )}
            </Collapse>
            {shouldShowExcessiveLength && this.props.configJSON?.enableExcessiveLengthOption && (
            <ExcessiveLength
              data={{
                isExcessiveLength: editInfo.isExcessiveLength,
                excessiveLengthValue: {
                  feet: editInfo.excessiveLength,
                  inches: editInfo.excessiveLengthInches
                }
              }}
              excessiveLengthError={errorInfo.excessiveLength}
              handleExcessiveLengthFeetChange={this.handleChange('excessiveLength')}
              handleExcessiveLengthInchesChange={this.handleChange('excessiveLengthInches')}
              handleIsExcessiveLengthChange={this.handleChange('isExcessiveLength')}
              maxAllowedTrailerLength={routeData.trailer.length}
              rowDescription={MESSAGES.PROCESS_PICKUP_OR_DELIVERY.EXCESSIVE_LENGTH_DESCRIPTION}
              collapseOpen={(editInfo.isExcessiveLength === appConstants.EXCESSIVE_SHIPMENT.YES)}
              customClasses={{headerStyle:classes.headerStyle}}
              options={getExcessiveShipmentList().filter((option) =>
                option.value !== appConstants.EXCESSIVE_SHIPMENT.CAN_NOT_SEE
              )}
          />
          )}
          {!isReturnOrSNDDelivery && this.props.configJSON?.enableShrinkWrapOption && (
            <ShrinkWrap
              handleChange={this.handleChange}
              editInfo={editInfo}
              errorInfo={errorInfo}
            />
          )}
          {isTADelivery && !stopHasMultiplePros && (
            <SelectBills
              stopsList={getPendingStops(routeData.stops)}
              currentStopData={stopData}
              updateStopSelection={updateStopSelection}
            />
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default compose(withAppConfig, withStyles(styles))(Form);
